import { TreeNode, TreeNodeType } from ".";
import { StepItem } from "~/components/build/Show/pages/steps/list/components/TreeNode/StepItem";
import useCurrentJobOrStep from "~/components/build/Show/lib/useCurrentJobOrStep";
import { CommandStep, isFailed } from "~/lib/pipeline";
import useQueryParams from "~/components/build/Show/lib/useQueryParams";

interface Props {
  step: CommandStep;
  depth?: number;
}

export function CommandStepItem(props: Props) {
  const { currentStep } = useCurrentJobOrStep();
  const params = useQueryParams();

  return (
    <StepItem
      {...props}
      active={
        props.step.uuid === currentStep?.uuid ||
        (Boolean(params.jobUuid) && props.step.statistics?.latestJobId === params.jobUuid)
      }
      failed={isFailed(props.step)}
    />
  );
}

export const createCommandStepNode = (step: CommandStep): TreeNode => ({
  id: step.uuid,
  type: TreeNodeType.StepCommand,
  render: (props) => <CommandStepItem step={step} {...props} />,
});
